<template>
  <div ref="sl" class="keen-slider ingredients-slider !overflow-visible">
    <div
      v-for="(item, index) in sorted"
      :key="index"
      class="keen-slider__slide ingredients-slider__slide flex flex-col rounded-[10px] bg-white px-20 py-[28px] text-center"
    >
      <h3
        class="mb-10 font-degular text-[25px] leading-[27px] max-sm:text-xl font-medium capitalize text-blue mt-auto"
      >
        {{ item?.title }}
      </h3>

      <img
        v-if="item?.url"
        :src="item.url"
        :alt="item?.title"
        class="mx-auto mb-20 aspect-square max-w-full object-contain"
      />
      <span
        v-if="item?.children && item.children[0]"
        class="mb-15 block body font-medium text-black mx-auto min-h-[54px]"
      >
        {{ item.children[0]?.handle }}
      </span>
    </div>
  </div>

  <div v-if="slider" class="md:absolute md:bottom-[133px] md:left-0 z-10 flex items-center justify-center gap-10 max-md:mt-15">
    <button
      v-for="(_dot, idx) in dotHelper"
      :key="idx"
      type="button"
      class="ingredients-slider__dot h-15 w-15 rounded-full border border-blue"
      :class="current === idx ? '!bg-blue' : 'bg-transparent'"
      :aria-label="`Go to slide ${idx + 1}`"
      @click="slider.moveToIdx(idx)"
    />
  </div>
</template>

<script>
import {computed, ref} from "vue";
import {useKeenSlider} from "keen-slider/vue.es";
import "keen-slider/keen-slider.min.css";

export default {
  name: "IngredientsSlider",
  props: {
    views: {type: Number, default: 3},
    mob: {type: Number, default: 1.1},
    tags: {type: Array, default: () => []},
    orders: {type: String, default: ""},
  },
  computed: {
    sorted() {
      const valid = this.tags.filter(t => t && Object.keys(t).length > 0);
      return valid.length ? this.sortByOrders(valid) : valid;
    },
  },
  setup(props) {
    const current = ref(0);
    const [sl, slider] = useKeenSlider({
      loop: false,
      breakpoints: {
        "(max-width: 1024px)": {slides: {perView: 2, spacing: 16}},
        "(max-width: 640px)": {slides: {perView: props.mob, spacing: 16}},
      },
      slides: {perView: props.views, spacing: 20},
      slideChanged: s => (current.value = s.track.details.rel),
    });
    const dotHelper = computed(() => {
      if (!slider.value) return [];
      const perView =
        slider.value.options?.slides?.perView ?? props.views ?? 1;
      const total = slider.value.track.details.slides.length || 0;
      const count = Math.max(0, Math.ceil(total - perView + 1));
      return [...Array(count).keys()];
    });
    return {sl, slider, current, dotHelper};
  },
  methods: {
    normalize(text) {
      return text.toLowerCase().trim().replace(/\s+/g, " ");
    },
    sortByOrders(tags) {
      if (!this.orders || !this.orders.trim()) return tags;
      const orderArray = this.orders
        .toLowerCase()
        .split(",")
        .map(i => this.normalize(i))
        .filter(Boolean);
      if (!orderArray.length) return tags;
      const indexMap = orderArray.reduce((acc, o, i) => {
        acc[o] = i;
        return acc;
      }, {});
      const mapped = tags.map(tag => ({
        tag,
        index:
          indexMap[this.normalize(tag.title)] !== undefined
            ? indexMap[this.normalize(tag.title)]
            : Number.MAX_VALUE,
      }));
      const sorted = mapped.sort((a, b) => a.index - b.index).map(m => m.tag);
      const remaining = tags.filter(t => !sorted.includes(t));
      return [...sorted, ...remaining];
    },
  },
};
</script>
